import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
  textHeading: {
    lineHeight: '30px',
    letterSpacing: '1.26px',
    fontSize: '28px',
    fontWeight: 300,
  },
  generatedByContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
  },
  textHeadingTwo: {
    marginTop: 3,
    letterSpacing: '0.96px',
    fontSize: '24px',
    fontWeight: 500,
    lineHeight: '32px',
  },
  textGenerated: {
    color: '#404040',
    fontSize: '10px',
    fontWeight: 200,
    lineHeight: '12px',
    letterSpacing: '0.4px',
    textAlign: 'right',
  },
  subText: {
    letterSpacing: '0.4px',
  },
  logoPlatform: {
    height: 48,
    marginRight: '-19px',
    display: 'block',
  },
  textCertificateNumber: {
    letterSpacing: '0.4px',
  },
  textNameArtist: {
    marginTop: 44,
    minHeight: 32,
    letterSpacing: '1.12px',
  },
  certificateBadge: {
    position: 'absolute',
    top: -30,
    right: 0,
  },
  hideText: {
    opacity: 0,
    visibility: 'hidden',
  },
  textLetterSpacing: {
    letterSpacing: '0.56px',
  },
  textDescription: {
    width: 'calc(100% + 22px)',
    color: '#404040',
    fontSize: '14px',
    fontWeight: 200,
    lineHeight: '20px',
    letterSpacing: '0.56px',
    fontStyle: 'normal',

    '& strong': {
      color: '#404040',
      fontFamily: 'Readex Pro',
      fontSize: '14px',
      fontStyle: 'normal',
      fontWeight: '400 !important',
      lineHeight: '20px',
      letterSpacing: '0.56px',
    },
  },
}));

export default useStyles;
